<template>
    <ui-container class="py-8 space-y-8">
        <!-- Header. -->
        <ui-header :title="`Toolbox Talk - ${item.title}`" :subtitle="'ID #'+this.item.id">
            <template #actions>
                <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>
        <ui-data-grid>
            <ui-data-grid-item label="Toolbox Talk Reference" :value="item.reference"></ui-data-grid-item>
            <ui-data-grid-item wide label="Toolbox Talk Title" :value="item.title"></ui-data-grid-item>
            <ui-data-grid-item wide label="Toolbox Talk" :value="item.talk"></ui-data-grid-item>
        </ui-data-grid>

        <ui-data-grid-item label="Quick action" wide>
            <div class="flex flex-col md:flex-row flex-wrap -m-2">
                <ui-button-new class="m-2" icon="fas fa-route" @click="duplicate" success>Duplicate as New Toolbox Talk
                </ui-button-new>
                <a :href="item.getDownloadUrl()" tabindex="-1">
                    <ui-button-new class="m-2" icon="fas fa-file-pdf">Download As PDF</ui-button-new>
                </a>
                <ui-button-new class="m-2" icon="fas fa-print" @click="print">Print PDF</ui-button-new>
            </div>
        </ui-data-grid-item>


        <ui-data-grid>
            <ui-data-grid-item label="Created By">{{ item.createdBy }} on {{
                    item.createdOn
                }}
            </ui-data-grid-item>
            <ui-data-grid-item label="Last Updated By" v-if="item.lastUpdatedBy">{{
                    item.lastUpdatedBy
                }} on {{
                    item.lastUpdatedOn
                }}
            </ui-data-grid-item>
        </ui-data-grid>

    </ui-container>
</template>

<script>
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import UiContainer from "../../ui/UiContainer.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import {ToolboxTalkLibraryItem} from "@models";
import {uuid} from "../../../utils";

export default {
    components: {
        UiDataGridItem,
        UiDataGrid,
        UiButtonNew, UiDropdown, UiDropdownItem, UiContainer, AutoresizableTextarea},
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
        addItem: Function,
    },
    computed: {},
    data() {
        return {}
    },
    methods: {
        openDeleteModal() {
            const title = 'Are you sure you want to remove toolbox talk ' + this.item.reference + '?'
            const description = 'You are removing toolbox talk #' + this.item.id + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
        async duplicate() {
            let data = this.item.getFormAttributes();
            const toolbox_talk = await ToolboxTalkLibraryItem.create(uuid(),data);

            this.addItem(toolbox_talk, 0, (items) => {
                items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
            });
            this.edit(toolbox_talk);
        },
        print() {
            this.$emit('print', this.item.getPrintableUrl())
        },
    },
}
</script>
